import PropTypes from 'prop-types'
import Person from 'model/person/person'
import { isNil, pathOr } from 'ramda'
import Member from './member'

class User extends Person {
  constructor(init) {
    super(init)
    // console.log('> User constructor -', init)
    if (isNil(init)) return undefined
    this._abbr_name = init.abbr_name
    this._email = init.email
    this._member = new Member(init.member)
    this._first_name = init.first_name
    this._last_name = init.last_name
    this._last_session_at = init.last_session_at
    this._locale = init.locale
    this._locked_at = init.locked_at
    this._active = init.active
    this._onboarded = init.onboarded
    this._registration_status = init.registration_status
    this._profileSurvey = pathOr({}, ['profileSurvey'], init)
    this._verified = init.verified
    this._last_request_ago = init.last_request_ago
    this._last_session = init.last_session
    // todo model for the survey
  }

  static shape = {
    id: PropTypes.string.isRequired,
    verified: PropTypes.bool,
    abbr_name: PropTypes.string,
    email: PropTypes.string,
    member: PropTypes.object,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    last_session_at: PropTypes.string,
    locale: PropTypes.string,
    locked_at: PropTypes.string,
    active: PropTypes.bool,
    onboarded: PropTypes.bool,
    registration_status: PropTypes.string,
    profileSurvey: PropTypes.object,
    last_request_ago: PropTypes.number,
    last_session: PropTypes.object
  }

  get verified() {
    return this._verified
  }

  get abbr_name() {
    return this._abbr_name
  }

  get email() {
    return this._email
  }

  get member() {
    return this._member
  }

  get first_name() {
    return this._first_name
  }

  get last_name() {
    return this._last_name
  }

  get last_session_at() {
    return this._last_session_at
  }

  get locale() {
    switch (this._locale) {
      case 'EN':
        return 'English'
      case 'ES':
        return 'Spanish'
      default:
        return 'N/A'
    }
  }

  get locked_at() {
    return this._locked_at
  }

  get active() {
    return this._active
  }

  get onboarded() {
    return this._onboarded
  }

  get registration_status() {
    return this._registration_status
  }

  get profileSurvey() {
    return this._profileSurvey
  }

  get last_request_ago() {
    return this._last_request_ago
  }

  // Calculable

  get isRecentlyActive() {
    return this._last_request_ago < 300
  }

  get last_session() {
    return this._last_session?.application.includes('web:') ? 'Web' : 'Mobile'
  }
}

export default User
